import styled from 'styled-components';

export const FieldWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-end;

  button {
    margin-right: 8px;
  }
`;

export const MultiInputWrapper = styled.div`
  margin: 24px 8px 0;

  button {
    margin-left: auto;
    margin-top: -33px;
  }
`;

export const InnerWrapper = styled.div`
  margin: 0 -8px;
`;

export const OuterWrapper = styled.div`
  width: calc(100% - 16px);
  margin: 24px 8px 0;
  animation: fade-in 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
`;
